import logo from "../NovoPedido/logo-pt2.png";
import { Button, Dimmer, Loader } from "semantic-ui-react";
import Situacoes from "./components/Situacoes";
import { useNavigate } from "react-router-dom";
import ExplicacaoSituacao from "./components/ExplicacaoSituacao";
import useGetPedido from "../../hooks/useGetPedido";
import MessagePadrao from "../../components/MessagePadrao";
import FormBusca from "./components/FormBusca";
import useTempStorage, {
  KEY_COOKIE_HASH_PEDIDO,
} from "../../hooks/useTempStorage";

function AcompanharPedido() {
  const navigate = useNavigate();
  const { isLoading, situacao } = useGetPedido();
  const { deleteCookie } = useTempStorage(KEY_COOKIE_HASH_PEDIDO);

  const consultarOutroCpf = () => {
    deleteCookie();
    navigate("/acompanhar-pedido");
  }

  const irParaAtividade = () => {
    navigate("/registrar-atividade");
  };

  return (
    <div>
      <div className="formFiliacao formCentral">
        <div className="logo">
          <img src={logo} alt="logo pt" />
        </div>
        <div className="fraseGuia">
          Seu pedido de filiação foi enviado para o Diretório Municipal.
        </div>
        <div className="formCampos">
          <Dimmer active={isLoading} inverted>
            <Loader >Aguarde ...</Loader>
          </Dimmer>
          {false && (
            <MessagePadrao content="Não foi possível localizar o pedido de filiação. Tente novamente" />
          )}
          {situacao && (
            <>
              <Situacoes situacaoFiliacao={situacao} />
              <ExplicacaoSituacao
                situacaoId={situacao}
                onClickAtividade={irParaAtividade}
              />
              <p style={{ textAlign: "center", marginTop: "2rem" }}>
                <Button className="btn-link" onClick={consultarOutroCpf}>
                  Consultar outro CPF
                </Button>
              </p>
            </>
          )}
          {!situacao && <FormBusca />}
        </div>
      </div>
    </div>
  );
}

export default AcompanharPedido;
